import * as React from "react";
import { requestPushTokenRegistration } from "../lib/utils/boot";

/**
 * 앱 마운트 및 포그라운드 복귀 시점에 네이티브 FCM 토큰 등록을 트리거한다.
 *
 * 기존에는 명시적 로그인 화면에서만 등록을 트리거해, 가입 응답으로 바로
 * 로그인되는 신규 가입자와 axios 인터셉터로만 토큰을 갱신하는 사용자가
 * FCM 등록을 한 번도 받지 못했다. 이 훅으로 인증 세션이 살아 있는 동안
 * 진입/복귀마다 등록을 보강한다. (실제 트리거는 인증/throttle 가드 적용)
 */
export function useFcmRegistration() {
  React.useEffect(() => {
    requestPushTokenRegistration();

    const handleForeground = () => {
      if (document.visibilityState === "visible") {
        requestPushTokenRegistration();
      }
    };

    document.addEventListener("visibilitychange", handleForeground);
    window.addEventListener("focus", handleForeground);

    return () => {
      document.removeEventListener("visibilitychange", handleForeground);
      window.removeEventListener("focus", handleForeground);
    };
  }, []);
}
